// Weco design system tokens. Values are taken from style-brief.md and
// verified against the reference prototype's computed styles.
//
// Two rules carry more weight than any individual hex code:
//   - One yellow accent per panel. Yellow marks the cam id, the single
//     priority number, the 2px top edge of the priority plate, and the track
//     chip. Nothing else.
//   - Depth comes from value steps and 1px hairlines only: 0-2px corners, and
//     no shadows, glow or gradients anywhere.
export const COLORS = {
  ground: '#04081a',
  feedGround: '#080E26',
  headerFill: '#0A1130',
  // Plates let some of the frame through -- enough to place the readout on
  // the picture, not so much that mono labels lose the navy under them.
  plateFill: 'rgba(10, 17, 48, 0.72)',
  stackFill: 'rgba(8, 14, 38, 0.74)',
  hairline: 'rgba(219, 228, 236, 0.16)',
  plateBorder: 'rgba(219, 228, 236, 0.28)',
  gridLine: 'rgba(219, 228, 236, 0.09)',
  meanLine: 'rgba(219, 228, 236, 0.30)',
  text: '#DBE4EC',
  label: '#8A9299',
  accent: '#F5C400',
  live: '#C8E600',
  alert: '#E4572E',
};

export const MONO = '"IBM Plex Mono", ui-monospace, monospace';
export const DISPLAY = 'Archivo, system-ui, sans-serif';

// Every mono label: 600, uppercase, wide tracking, tabular figures so digits
// never jitter as values refresh.
export const monoLabel = `
  font-family: ${MONO};
  font-weight: 600;
  font-size: 11px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  font-variant-numeric: tabular-nums;
`;

// Value rows sit a touch smaller and tighter than the section labels.
export const monoValue = `
  font-family: ${MONO};
  font-weight: 600;
  font-size: 10px;
  letter-spacing: 0.12em;
  font-variant-numeric: tabular-nums;
`;

export const display = `
  font-family: ${DISPLAY};
  font-weight: 700;
  font-stretch: 112%;
  letter-spacing: -0.02em;
`;

// Overlay plates never intercept pointer events -- they sit over live video.
export const plate = `
  position: absolute;
  background: ${COLORS.plateFill};
  border: 1px solid ${COLORS.plateBorder};
  padding: 8px;
  pointer-events: none;
`;
